$(document).ready(function () {
  async function updateCartDrawer() {
    const res = await fetch("/?section_id=add-cart-popup");
    const text = await res.text();

    const html = document.createElement("div");
    html.innerHTML = text;

    // Null-Guards (Clarity-Fix 2026-07-09): auf Templates/Layouts ohne
    // .cart-drawer warf das 'Cannot set properties of null (setting innerHTML)'
    const newBoxSource = html.querySelector(".cart-drawer");
    const drawerTarget = document.querySelector(".cart-drawer");
    if (newBoxSource && drawerTarget) {
      drawerTarget.innerHTML = newBoxSource.innerHTML;
    }
    changeItemCounter();
    addCartEventListeners();
  }

  function changeItemCounter(){
    axios
    .get("/cart.js")
    .then(function (response) {
        const cartCountEl = document.querySelector("#CartCount");
        if (cartCountEl) cartCountEl.innerHTML = '<span data-cart-count="">' + response.data.item_count + '</span>';
    });
  }

  /* Die Zeilennummer (1-basiert) DER EINZIGE tragfaehige Bezug auf eine
     Warenkorbzeile — siehe changeItemQuantity(). Sie ergibt sich aus der
     Position im Drawer, und der Drawer rendert `for item in cart.items` in
     genau der Reihenfolge, die /cart/change.js unter `line` erwartet. */
  function zeilenNummer(item) {
    const alle = Array.prototype.slice.call(document.querySelectorAll(".cart-item"));
    return alle.indexOf(item) + 1;
  }

  function addCartEventListeners() {
    document.querySelectorAll(".item-count-edit button").forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        const isPlus = button.classList.contains("cart-quantity-increase");
        const input = button.parentElement.querySelector("input");
        const item = button.closest(".cart-item");
        const value = Number(input.value);
        if (!item || !isFinite(value)) return;

        const newValue = isPlus ? value + 1 : value - 1;
        /* Unter 1 gehoert die Zeile entfernt, nicht auf 0 gesetzt und stehen
           gelassen — sonst zeigt der Drawer eine Zeile mit Menge 0. */
        if (newValue < 1) {
          changeItemQuantity(zeilenNummer(item), 0);
          return;
        }
        input.value = newValue;
        changeItemQuantity(zeilenNummer(item), newValue);
      });
    });

    /* Freie Eingabe. Bis 2026-08-07 hatte das Feld UEBERHAUPT KEINEN Handler:
       eine getippte Zahl erreichte den Warenkorb nie. Schlimmer noch, das Feld
       steht in `{% form 'cart' %}` — ein Enter darin loest die implizite
       Formular-Absendung aus und traf damit den ERSTEN Submit-Button im
       Formular. Gemessen 2026-08-07: "7" getippt + Enter -> POST quantity 6,
       weil der Minus-Knopf getroffen wurde. Ohne preventDefault waere es nach
       dem type="button"-Fix statt dessen der Checkout-Button geworden. */
    document.querySelectorAll(".cart-item input.cart-item-count").forEach((input) => {
      /* Enter ruft anwenden() und danach blur() — blur loest seinerseits
         `change` aus. Ohne diesen Merker ginge derselbe Wert zweimal raus. */
      let zuletztGesendet = input.value;
      const anwenden = () => {
        const item = input.closest(".cart-item");
        if (!item) return;
        const n = parseInt(input.value, 10);
        if (!isFinite(n) || n < 0) {
          updateCartDrawer();
          return;
        }
        if (String(n) === zuletztGesendet) return;
        zuletztGesendet = String(n);
        changeItemQuantity(zeilenNummer(item), n);
      };
      input.addEventListener("keydown", (e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          anwenden();
          input.blur();
        }
      });
      input.addEventListener("change", anwenden);
    });

    document.querySelectorAll(".remove-cart-item").forEach((remove) => {
      remove.addEventListener("click", (e) => {
        e.preventDefault();
        const item = remove.closest(".cart-item");
        if (!item) return;
        changeItemQuantity(zeilenNummer(item), 0);
      });
    });

    $('.btn--add-to-cart-popup').on('click', function() {
      let selectedUpsellSize = $('.upsellSelectForm').val();
      let upsellFormData = {
       items: [
         {
           id: selectedUpsellSize,
           quantity: 1,
         },
       ],
     };
   
       fetch(window.Shopify.routes.root + "cart/add.js", {
         method: "POST",
         headers: {
           "Content-Type": "application/json",
         },
         body: JSON.stringify(upsellFormData),
       })
       .then((response) => {
         updateCartDrawer();
         return response.json();
       })
       .catch((error) => {
         console.error("Error:", error);
       });
     });

  }

  /* ------------------------------------------------------------------------
     preisAnzeigeSetzen — der Haupt-Preis wird NUR ueberschrieben, wenn es
     etwas Besseres zu schreiben gibt.

     WARUM ES DIESE FUNKTION GIBT (Live-Vorfall 2026-08-07).
     Auf beiden Crystal-Cacao-Kaufseiten stand gross und fett "undefined"
     neben "Taxes included". Serverseitig war der Preis KORREKT — das Liquid
     (snippets/new-price.liquid) lieferte "$89". Zerstoert hat ihn genau die
     Zeile hier: die vier Preis-Schreibstellen liefen UNBEDINGT, auch wenn
     ihre Quelle gar nicht existierte.

     Die Quelle verschwand am selben Tag durch einen KORREKTEN Fix: Crystal
     Cacao hat nur eine Groesse, und ein <select> mit genau einer Option ist
     ein Bedienelement, das nichts bedient — also wurden #productSelectKakao
     und #productSelectTwo in den Kakao-Templates auf `variants.size > 1`
     gegatet. Damit gab `$('#productSelectKakao option:selected')` ein leeres
     jQuery-Set, `.data("variant-price")` gab `undefined`, und
     `undefined + " " + "<span>..."` ergab in JavaScript still den String
     "undefined ...". Kein Fehler in der Konsole, kein 500er, nichts —
     die teuerste Stelle der Seite war eine String-Konkatenation.

     Der Kauf-Button war von derselben Gate-Aenderung betroffen und wurde
     abgesichert (`$('#productSelectKakao').val()`); der Preis-Pfad wurde
     dabei uebersehen. Deshalb steht die Absicherung jetzt an EINER Stelle
     statt viermal einzeln.

     DIE REGEL: Liquid hat bereits einen gueltigen Preis gerendert. Hat das
     JS keinen besseren, laesst es ihn stehen. Ein fehlender Waehler ist kein
     Grund, eine korrekte Anzeige zu loeschen. Verworfen wird nicht nur
     `undefined`, sondern jeder Wert, der keine Ziffer traegt — "null",
     "NaN" und der leere String sehen dem Kunden gegenueber genauso aus.
     ------------------------------------------------------------------------ */
  function preisAnzeigeSetzen(zielSelektor, wert){
    var ziel = $(zielSelektor);
    if (ziel.length === 0) return;
    var text = (wert === undefined || wert === null) ? '' : String(wert).trim();
    if (text === '' || text === 'undefined' || text === 'null' || text === 'NaN') return;
    if (!/[0-9]/.test(text)) return;   // ein Preis ohne Ziffer ist kein Preis
    ziel.html(text + " " + "<span class='product-tax-included-label'>Taxes included</span>");
  }

  $('#productSelectTwo').on("change", function(){
    let selectedVariantPrice = $('#productSelectTwo option:selected').data("variant-price");
    let selectedVariantId = $('#productSelectTwo option:selected').data("id");
    let selectedVariantAvailability = $('#productSelectTwo option:selected').data("available");

    preisAnzeigeSetzen('#product-page-new-design > div:nth-child(2) > div.product__price.kakao-price-two > div', selectedVariantPrice);
    /* Der Grundpreis wird nicht mehr hier gesetzt: er stand als fester
       Euro-String in einem USD-Shop und haing an einer fremden Variant-ID.
       Zustaendig ist jetzt assets/cacao-staffel.js, das die von Liquid
       gerechneten Werte aus den <option>-Attributen uebernimmt. */
    if(selectedVariantAvailability == 'soldout'){
      $('#add-to-cart-kakao').css("display", "none");
      $('#disabled-add-to-cart-kakao').css("display", "inline-block");
    } else {
      $('#disabled-add-to-cart-kakao').css("display", "none");
      $('#add-to-cart-kakao').css("display", "inline-block");
    }

  })
  
    const selectedVariantPriceOnLoadKakao = $('#productSelectTwo option:selected').data("variant-price");
    const selectedVariantIdOnLoadKakao = $('#productSelectTwo option:selected').data("id");
    const selectedVariantAvailabilityOnLoadKakao = $('#productSelectTwo option:selected').data("available");

    preisAnzeigeSetzen('#product-page-new-design > div:nth-child(2) > div.product__price.kakao-price-two > div', selectedVariantPriceOnLoadKakao);
    /* Der Grundpreis wird nicht mehr hier gesetzt: er stand als fester
       Euro-String in einem USD-Shop und haing an einer fremden Variant-ID.
       Zustaendig ist jetzt assets/cacao-staffel.js, das die von Liquid
       gerechneten Werte aus den <option>-Attributen uebernimmt. */
    if(selectedVariantAvailabilityOnLoadKakao == 'soldout'){
      $('#add-to-cart-kakao').css("display", "none");
      $('#disabled-add-to-cart-kakao').css("display", "inline-block");
    } else {
      $('#disabled-add-to-cart-kakao').css("display", "none");
      $('#add-to-cart-kakao').css("display", "inline-block");
    }

    const selectedVariantPriceOnLoad = $('#productSelectKakao option:selected').data("variant-price");
    const selectedVariantIdOnLoad = $('#productSelectKakao option:selected').data("id");
    const selectedVariantAvailabilityOnLoad = $('#productSelectKakao option:selected').data("available");

    preisAnzeigeSetzen('#product-page-new-design > div:nth-child(2) > div.kakao-price-one > div', selectedVariantPriceOnLoad);
    
    /* Der Grundpreis wird nicht mehr hier gesetzt: er stand als fester
       Euro-String in einem USD-Shop und haing an einer fremden Variant-ID.
       Zustaendig ist jetzt assets/cacao-staffel.js, das die von Liquid
       gerechneten Werte aus den <option>-Attributen uebernimmt. */
    /* #add-to-cart-kakao-one ist der Kakao-Button aus product-template-cropped-kakao-1.
       Er hiess bis 2026-08-07 "add-to-cart" und bekam dadurch einen zweiten,
       fremden Klick-Handler (Doppel-Add, N+1 im Warenkorb). Die generische
       #add-to-cart bleibt in der Auswahl stehen: auf Nicht-Kakao-Seiten soll
       sich hier nichts aendern, dort existiert die neue id schlicht nicht. */
    if(selectedVariantAvailabilityOnLoad == 'soldout'){
      $('#add-to-cart, #add-to-cart-kakao-one').css("display", "none");
      $('#disabled-add-to-cart').css("display", "inline-block");
    } else {
      $('#disabled-add-to-cart').css("display", "none");
      $('#add-to-cart, #add-to-cart-kakao-one').css("display", "inline-block");
    }

  $('#productSelectKakao').on("change", function(){
    let selectedVariantPrice = $('#productSelectKakao option:selected').data("variant-price");
    let selectedVariantId = $('#productSelectKakao option:selected').data("id");
    let selectedVariantAvailability = $('#productSelectKakao option:selected').data("available");

    preisAnzeigeSetzen('#product-page-new-design > div:nth-child(2) > div.kakao-price-one > div', selectedVariantPrice);
    
    /* Der Grundpreis wird nicht mehr hier gesetzt: er stand als fester
       Euro-String in einem USD-Shop und haing an einer fremden Variant-ID.
       Zustaendig ist jetzt assets/cacao-staffel.js, das die von Liquid
       gerechneten Werte aus den <option>-Attributen uebernimmt. */
    if(selectedVariantAvailability == 'soldout'){
      $('#add-to-cart, #add-to-cart-kakao-one').css("display", "none");
      $('#disabled-add-to-cart').css("display", "inline-block");
    } else {
      $('#disabled-add-to-cart').css("display", "none");
      $('#add-to-cart, #add-to-cart-kakao-one').css("display", "inline-block");
    }
  })

  

  $('#add-to-cart').on('click', function() {
  let mainVariantId = $('#add-to-cart').data("variant-id");

    let upsellVariantId = $(".upsell-wrapper").data("upsell-product");
    const upsellChecked = $("#upsell-button-yes").is(":checked");
    let formData;

    if (upsellChecked) {
      formData = {
        items: [
          {
            id: mainVariantId,
            quantity: 1,
          },
          {
            id: upsellVariantId,
            quantity: 1,
          },
        ],
      };
    } else {
      formData = {
        items: [
          {
            id: mainVariantId,
            quantity: 1,
          },
        ],
      };
    }

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
    .then((response) => {
      updateCartDrawer();
      openCartDrawer();
      changeItemCounter()    
      return response.json();
    })
    .catch((error) => {
      console.error("Error:", error);
    });
  });



  $('.add-to-cart-variants').on('click', function() {
  let mainVariantId = $('.add-to-cart-variants').data("variant-id");
    // Get the current value of data-variant-id when the button is clicked
    console.log(mainVariantId);
    let selectedOptionValue = $('#productSelect').val();
    console.log(selectedOptionValue)

    if(mainVariantId !== selectedOptionValue){
      mainVariantId = selectedOptionValue
    }

    let upsellVariantId = $(".upsell-wrapper").data("upsell-product");
    const upsellChecked = $("#upsell-button-yes").is(":checked");
    let formData;

    if (upsellChecked) {
      formData = {
        items: [
          {
            id: mainVariantId,
            quantity: 1,
          },
          {
            id: upsellVariantId,
            quantity: 1,
          },
        ],
      };
    } else {
      formData = {
        items: [
          {
            id: mainVariantId,
            quantity: 1,
          },
        ],
      };
    }

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
    .then((response) => {
      updateCartDrawer();
      openCartDrawer();    
      changeItemCounter()    
      return response.json();
    })
    .catch((error) => {
      console.error("Error:", error);
    });
  });

  $('.add-to-cart-variants-kakao').on('click', function() {
  let mainVariantId = $('.add-to-cart-variants-kakao').data("variant-id");
    let selectedOptionValue = $('#productSelectTwo').val();

    /* NUR uebernehmen, wenn der Waehler wirklich einen Wert liefert. Hat das
       Produkt genau eine Groesse, rendert die Section seit 2026-08-07 statt des
       Ein-Options-<select> eine reine Anzeige — `.val()` ist dann `undefined`,
       und ein ungepruefter Ueberschreiber haette die Variant-ID geloescht und
       damit den Kauf-Button unbrauchbar gemacht. */
    if (selectedOptionValue) {
      mainVariantId = selectedOptionValue;
    }

    let upsellVariantId = $(".upsell-wrapper").data("upsell-product");
    const upsellChecked = $("#upsell-button-yes").is(":checked");
    let formData;

    if (upsellChecked) {
      formData = {
        items: [
          {
            id: mainVariantId,
            /* Menge aus dem Kakao-Mengenwaehler (assets/cacao-staffel.js).
               Stand hier fest auf 1 — der Waehler waere sonst Deko.
               NUR die Hauptdose: das Upsell-Produkt unten behaelt bewusst
               quantity 1, sonst vervielfacht die Mengenwahl still das Upsell. */
            quantity: (typeof window.cacaoStaffelMenge === 'function') ? window.cacaoStaffelMenge() : 1,
          },
          {
            id: upsellVariantId,
            quantity: 1,
          },
        ],
      };
    } else {
      formData = {
        items: [
          {
            id: mainVariantId,
            /* Menge aus dem Kakao-Mengenwaehler (assets/cacao-staffel.js).
               Stand hier fest auf 1 — der Waehler waere sonst Deko.
               NUR die Hauptdose: das Upsell-Produkt unten behaelt bewusst
               quantity 1, sonst vervielfacht die Mengenwahl still das Upsell. */
            quantity: (typeof window.cacaoStaffelMenge === 'function') ? window.cacaoStaffelMenge() : 1,
          },
        ],
      };
    }

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
    .then((response) => {
      updateCartDrawer();
      openCartDrawer();    
      return response.json();
    })
    .catch((error) => {
      console.error("Error:", error);
    });
  });

  $('.add-to-cart-variants-kakao-two').on('click', function() {
  let mainVariantId = $('.add-to-cart-variants-kakao-two').data("variant-id");
    let selectedOptionValue = $('#productSelectKakao').val();

    /* Siehe Zwilling oben: leerer Waehler darf die Variant-ID nicht loeschen. */
    if (selectedOptionValue) {
      mainVariantId = selectedOptionValue;
    }

    let upsellVariantId = $(".upsell-wrapper").data("upsell-product");
    const upsellChecked = $("#upsell-button-yes").is(":checked");
    let formData;

    if (upsellChecked) {
      formData = {
        items: [
          {
            id: mainVariantId,
            /* Menge aus dem Kakao-Mengenwaehler (assets/cacao-staffel.js).
               Stand hier fest auf 1 — der Waehler waere sonst Deko.
               NUR die Hauptdose: das Upsell-Produkt unten behaelt bewusst
               quantity 1, sonst vervielfacht die Mengenwahl still das Upsell. */
            quantity: (typeof window.cacaoStaffelMenge === 'function') ? window.cacaoStaffelMenge() : 1,
          },
          {
            id: upsellVariantId,
            quantity: 1,
          },
        ],
      };
    } else {
      formData = {
        items: [
          {
            id: mainVariantId,
            /* Menge aus dem Kakao-Mengenwaehler (assets/cacao-staffel.js).
               Stand hier fest auf 1 — der Waehler waere sonst Deko.
               NUR die Hauptdose: das Upsell-Produkt unten behaelt bewusst
               quantity 1, sonst vervielfacht die Mengenwahl still das Upsell. */
            quantity: (typeof window.cacaoStaffelMenge === 'function') ? window.cacaoStaffelMenge() : 1,
          },
        ],
      };
    }

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
    .then((response) => {
      updateCartDrawer();
      openCartDrawer();    
      return response.json();
    })
    .catch((error) => {
      console.error("Error:", error);
    });
  });


 

  addItemToCartById()
  addCartEventListeners();
  variantAltAddItemToCart()

  function formatMoney(cents, format) {
    if (typeof cents == "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || this.money_format;

    function defaultOption(opt, def) {
      return typeof opt == "undefined" ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ",");
      decimal = defaultOption(decimal, ".");

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split("."),
        dollars = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands
        ),
        cents = parts[1] ? decimal + parts[1] : "";

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  /* Mengenaenderungen laufen streng nacheinander. Zwei parallele POSTs auf
     denselben Warenkorb koennen in beliebiger Reihenfolge ankommen — dann
     gewinnt nicht der letzte Klick, sondern der letzte Server-Schreiber, und
     die Anzeige laeuft von der Wahrheit weg. */
  let mengenKette = Promise.resolve();

  /*
   * WARUM `line` UND NICHT `id`.
   *
   * Bis 2026-08-07 schickte diese Funktion den im Markup gerenderten Line-Item-
   * Key (`data-key`, z. B. "56904053981449:ded5ea81…"). Der Key ist aber nur
   * bis zur ERSTEN Mengenaenderung gueltig; danach antwortet Shopify auf genau
   * denselben Key mit
   *     HTTP 400 {"status":"bad_request","message":"no valid id or line parameter"}
   * Live gemessen 2026-08-07 am echten Shop: add 3 -> change(id=key, 5) = 200,
   * anschliessend change(id=key, 2) = 400 und change(id=key, 1) = 400, waehrend
   * change(line=1, …) in derselben Sitzung durchgehend 200 lieferte.
   *
   * Weil der Drawer nach einer Mengenaenderung zudem NIE neu gerendert wurde,
   * blieb der veraltete Key im DOM stehen — die Steuerung funktionierte also
   * genau einmal je Renderung und war danach dauerhaft tot. Beide Haelften sind
   * hier behoben: `line` statt `id`, und ein Neu-Rendern nach jeder Aenderung.
   *
   * Der Fehler wurde ausserdem verschluckt: das alte `.then(...)` hatte kein
   * `.catch(...)`, deshalb zeigte das Eingabefeld weiter die Wunschzahl,
   * waehrend der Warenkorb unveraendert blieb.
   */
  function changeItemQuantity(line, quantity) {
    mengenKette = mengenKette
      .then(function () {
        return axios.post("/cart/change.js", { line: line, quantity: quantity });
      })
      .then(function (res) {
        const formatEl = document.querySelector("[data-money-format]");
        const format = formatEl ? formatEl.getAttribute("data-money-format") : "";
        const cartCountEl = document.querySelector("#CartCount");
        if (cartCountEl) {
          cartCountEl.innerHTML = '<span data-cart-count="">' + res.data.item_count + "</span>";
        }
        const totalPriceEl = document.querySelector("#total-price");
        if (totalPriceEl) totalPriceEl.textContent = formatMoney(res.data.total_price, format);
        /* Neu rendern: holt Zeilenpreise, Zwischensumme, Zeilenreihenfolge und
           die Handler zurueck in Deckung mit dem echten Warenkorb. */
        return updateCartDrawer();
      })
      .catch(function (error) {
        console.error("Warenkorb-Menge konnte nicht gesetzt werden:", error);
        /* Nicht die Wunschzahl stehen lassen — den echten Stand zeigen. */
        return updateCartDrawer();
      });
    return mengenKette;
  }

  function addItemToCartById(){
    document.querySelectorAll('.add-to-cart-by-id').forEach((button) => {
      button.addEventListener('click', () => {
        let formData = {
          'items': [{
            'id': button.dataset.productToSell,
            'quantity': 1
          }]        
        };
  
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => {
          updateCartDrawer();
          openCartDrawer();    
          changeItemCounter()    
          return response.json();
        })
        .catch((error) => {
          console.error('Error:', error);
        });
      });
    });
  }

  function variantAltAddItemToCart(){
    document.querySelectorAll('.add-to-cart-by-id-variant').forEach((button) =>  {
      button.addEventListener('click', () => {
        let value = document.getElementById('alt-product-select').value;
        let formData = {
          'items': [{
            'id': value,
            'quantity': 1
          }]        
        };
  
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => {
          updateCartDrawer();
          openCartDrawer();    
          changeItemCounter()    
          return response.json();
        })
        .catch((error) => {
          console.error('Error:', error);
        });
      })
    })
  }

});

